import {
  createStyles,
  Grid,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { PortalRoutes } from "constants/routes";
import history from "features/app/History";
import React, { type ComponentType, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import type { RootState } from "redux/reducers";
import FormLocation from "./FormLocation";
import FormStep from "./formStep";
import PastureRegistrations from "./PastureRegistrations";
import { useTranslations } from "adapters/i18n";

type StateProps = ReturnType<typeof mapStateToProps>;
type OwnProps = unknown;

type NewFarmFormContainerProps = OwnProps &
  StateProps &
  WithStyles<typeof styles>;

function NewFarmFormContainer({
  classes,
  forages,
  isPastureModified,
  newPasturesCoords,
  pastureErrors,
  primePastures,
  retreats,
  selectedFarmId,
  selectedPasture,
  selectedRetreatId,
  toggles,
  trough,
  troughErrors,
}: NewFarmFormContainerProps) {
  const { t } = useTranslations();

  const steps = [t("pasture:location"), t("pasture:draw-pasture")];

  const [activeStep, setActiveStep] = useState<number>(0);

  const [targetTrough, setTargetTrough] = useState(trough);
  const [creepTrough, setCreepTrough] = useState();
  const [newPasture, setNewPasture] = useState(selectedPasture);
  const [location, setLocation] = useState<string>("");
  const [lat, setLat] = useState<string>("");
  const [long, setLong] = useState<string>("");

  const handleOnNext = () => {
    setActiveStep(1);
  };

  const handleLocationBack = () => {
    history.replace(PortalRoutes.PASTURE_REGISTRATIONS);
  };

  const handlePastureBack = () => {
    setActiveStep(0);
  };

  return (
    <Grid container xs className={classes.root} direction="column">
      <FormStep steps={steps} activeStep={activeStep} />

      <Grid container item xs>
        {activeStep === 0 && (
          <FormLocation
            onBack={handleLocationBack}
            onNext={handleOnNext}
            location={location}
            setLocation={setLocation}
            lat={lat}
            setLat={setLat}
            long={long}
            setLong={setLong}
          />
        )}
        {activeStep === 1 && (
          <PastureRegistrations
            AreaNovoPasto={selectedPasture.AreaNovoPasto}
            cadastroPastoModificado={isPastureModified}
            CoordenadasNovosPastos={newPasturesCoords}
            creepTrough={creepTrough}
            errosCocho={troughErrors}
            errosPasto={pastureErrors}
            Forragens={forages}
            id="containerCadastro"
            IdFazenda={selectedFarmId}
            IdRetiro={selectedRetreatId}
            isEdit={false}
            onBack={handlePastureBack}
            PastoSelecionado={selectedPasture}
            PastosPrime={primePastures}
            pasture={newPasture}
            Retiros={retreats}
            setCreepTrough={setCreepTrough}
            setPasture={setNewPasture}
            setTrough={setTargetTrough}
            Toggles={toggles}
            trough={targetTrough}
          />
        )}
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state: RootState) => ({
  forages: state.forragem.Forragens,
  // @ts-expect-error - pasto reducer not typed yet
  isPastureModified: state.pasto.cadastroPastoModificado,
  // @ts-expect-error - pasto reducer not typed yet
  newPasturesCoords: state.pasto.CoordenadasNovoPasto,
  // @ts-expect-error - pasto reducer not typed yet
  pastureErrors: state.pasto.erros,
  primePastures: state.pastosPrime.PastosPrime,
  // @ts-expect-error - retiro reducer not typed yet
  retreats: state.retiro.Retiros,
  selectedFarmId: state.fazenda.FazendaSelecionada,
  // @ts-expect-error - pasto reducer not typed yet
  selectedPasture: state.pasto.PastoSelecionado,
  // @ts-expect-error - retiro reducer not typed yet
  selectedRetreatId: state.retiro.RetiroSelecionado,
  toggles: state.fazenda.Toggles,
  trough: state.cocho.Cocho,
  troughErrors: state.cocho.erros,
});

const styles = () =>
  createStyles({
    root: {
      height: "100%",
      width: "100%",
      padding: "32px 40px",
      display: "flex",
    },
  });

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(NewFarmFormContainer) as ComponentType<OwnProps>;
